export default __webpack_public_path__ + "static/media/brewery.a3eecd2b.png";